import { theme, VStack } from '@sg/garnish';
import { useProductNutritionData } from '@sg/shared-fe/features/menu';
import { ProductDetails } from '@sg/shared-fe/features/product-details';

import { type BaseProduct } from '../../ProductDetails.types';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductNutritionData = (props: Props) => {
  const { baseProduct } = props;

  // ─── Derived Data ────────────────────────────────────────────────────

  const completeNutritionData = useProductNutritionData({ baseProduct });

  const {
    calories,
    caloriesFromFat,
    saturatedFatG,
    transFatG,
    cholesterolMg,
    sodiumMg,
    totalCarbsG,
    dietaryFiberG,
    sugarsG,
    proteinG,
  } = completeNutritionData;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <VStack gap={theme.spacing['4']}>
      {calories ? (
        <ProductDetails.NutritionEntries.List>
          <ProductDetails.NutritionEntries.Item title={calories.label} value={calories.value} />
        </ProductDetails.NutritionEntries.List>
      ) : null}

      {caloriesFromFat || saturatedFatG || transFatG ? (
        <ProductDetails.NutritionEntries.Divider />
      ) : null}

      <ProductDetails.NutritionEntries.List>
        {caloriesFromFat ? (
          <ProductDetails.NutritionEntries.Item
            title={caloriesFromFat.label}
            value={caloriesFromFat.value}
          />
        ) : null}

        {saturatedFatG ? (
          <ProductDetails.NutritionEntries.Item
            title={saturatedFatG.label}
            value={saturatedFatG.value}
          />
        ) : null}

        {transFatG ? (
          <ProductDetails.NutritionEntries.Item title={transFatG.label} value={transFatG.value} />
        ) : null}
      </ProductDetails.NutritionEntries.List>

      {cholesterolMg || sodiumMg ? <ProductDetails.NutritionEntries.Divider /> : null}

      <ProductDetails.NutritionEntries.List>
        {cholesterolMg ? (
          <ProductDetails.NutritionEntries.Item
            title={cholesterolMg.label}
            value={cholesterolMg.value}
          />
        ) : null}

        {sodiumMg ? (
          <ProductDetails.NutritionEntries.Item title={sodiumMg.label} value={sodiumMg.value} />
        ) : null}
      </ProductDetails.NutritionEntries.List>

      {totalCarbsG || dietaryFiberG || sugarsG ? <ProductDetails.NutritionEntries.Divider /> : null}

      <ProductDetails.NutritionEntries.List>
        {totalCarbsG ? (
          <ProductDetails.NutritionEntries.Item
            title={totalCarbsG.label}
            value={totalCarbsG.value}
          />
        ) : null}

        {dietaryFiberG ? (
          <ProductDetails.NutritionEntries.Item
            title={dietaryFiberG.label}
            value={dietaryFiberG.value}
          />
        ) : null}

        {sugarsG ? (
          <ProductDetails.NutritionEntries.Item title={sugarsG.label} value={sugarsG.value} />
        ) : null}
      </ProductDetails.NutritionEntries.List>

      {proteinG ? <ProductDetails.NutritionEntries.Divider /> : null}

      <ProductDetails.NutritionEntries.List>
        {proteinG ? (
          <ProductDetails.NutritionEntries.Item title={proteinG.label} value={proteinG.value} />
        ) : null}
      </ProductDetails.NutritionEntries.List>
    </VStack>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  baseProduct: BaseProduct;
};
